import { Box, Typography } from '@mui/material';
import { lang } from 'src/utils';

interface CanaryBannerProps {
  visible: boolean;
}

export const CanaryBanner = ({ visible }: CanaryBannerProps) => {
  if (!visible) return null;

  return (
    <Box
      sx={{
        backgroundColor: '#FEC325',
        // Dual-menu pages (MiniSidebar showing): align flush with it, no extra gap.
        // Single-menu pages (no MiniSidebar): align with the page content's own padding.
        marginLeft:
          'max(var(--secondary-rail-width, 0px), var(--content-horizontal-padding, 0px))',
        padding: '10px 0',
        textAlign: 'center',
      }}>
      <Typography sx={{ color: '#000000', fontWeight: 500 }}>
        {lang.canaryBannerMessage}
      </Typography>
    </Box>
  );
};
